import { Button, Grid, Paper, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  createProjectSamples, getApplications, getProjects, getProjectSample, getProjectsFilter, updateSampleData
} from "../../store/actions";

interface Props {
  getProjects: any;
  projects: any;
  getProjectsFilter: any;
  createProjectSamples: any;
  updateSampleData: any;
  getApplications: any;
  applications: any;
  getProjectSample: any;
  projectFilterData: any;
  // projectSampleData: any;
  projectSamplesdata: any;
}
const Onboarding: React.FC<Props> = ({
  projects,
  getProjects,
  createProjectSamples,
  updateSampleData,
  getApplications,
  applications,
  getProjectSample,
  projectSamplesdata,
  // projectSampleData
}) => {
  const history = useHistory();
  // Parameters
  const { projectId, subProjectId } = useParams<{
    projectId: string;
    subProjectId: string;
  }>();
  // Current selected project data
  const [project, setProject] = useState<any>(null);
  const [editId, setEditId] = useState<any>("");
  // Currently selected subproject data
  const [subProject, setSubProject] = useState<any>(null);
  const timer = useRef<any>(0);
  // sample Names
  const [sampleNames, setSampleNames] = useState<any>([]);
  const [subproject, setDisplaySubproject] = useState<string>("");
  const [displayProject, setDisplayProject] = useState<string>("");
  const [segments, setSegments] = React.useState([])
  // Initialize sample names based on sample count
  useEffect(() => {
    if (subProject?.sampleCount && !subProject?.sampleRegistered) {
      setSampleNames(new Array(subProject?.sampleCount).fill(""));
    }
    if (subProject?.sampleRegistered) {
      getProjectSample(subProject?._id);
    }
  }, [subProject]);

  // Initialize project and subproject based on projectId and subProjectId
  useEffect(() => {
    if (projects) {
      if (projectId) {
        const projectData = projects?.results?.find(
          (p: any) => p._id === projectId
        );
        setDisplayProject(projectData?.projectId)
        setProject(projectData);
        if (subProjectId) {
          const subProjectData = projectData?.subProjects.find(
            (sp: any) => sp._id === subProjectId
          );
          setDisplaySubproject(subProjectData?.title)
          setSubProject(subProjectData);
        }
      }
    }
  }, [projects, projectId, subProjectId]);

  // If sample registered then update sample data
  useEffect(() => {
    if (subProject?.sampleRegistered) {
      let sNames = Object.values(projectSamplesdata);
      if (subProject?.sampleCount - sNames?.length >=0)
        setSampleNames([...sNames, ...new Array(subProject?.sampleCount - sNames?.length).fill("")]);
    }
  }, [subProject, projectSamplesdata]);

  useEffect(() => {
    getApplications();
    getProjects("");
  }, []);

  const handleInputChange = (index: any, val: any,) => {
    const newSampleNames = [...sampleNames];
    newSampleNames[index] = val;
    setSampleNames(newSampleNames);
  };

  const submitForm = async (e: any) => {
    e.preventDefault();
    const sampleData = {
      sampleNames: sampleNames,
      projectId: project?._id,
      subProjectId: subProject?._id,
    };
    // If subproject sample is registered update else create new sample
    if (subProject?.sampleRegistered) {
      await updateSampleData({
        samples: Object.keys(projectSamplesdata).map(
          (key: any, index: number) => ({ id: key, name: sampleNames[index] })
        ),
        projectId: project?._id,
        subProjectId: subProject?._id,
        sampleNames: sampleNames.slice(Object.keys(projectSamplesdata).length)
      });
    } else {
      await createProjectSamples(sampleData);
    }
    history.push(`/dashboard/gnrelab/project-samples`);
  };

  const handlePaste = (index: number, e: any) => {
    let pasted: string = e.clipboardData.getData("text/plain")
    if (pasted) {
      // Try to split pasted by new line
      // Check if \r\n is present
      const names = pasted.split(/\r?\n/);
      const newSampleNames = [...sampleNames];
      for (let i = 0; i < names.length && (index + i) < sampleNames.length; i++)
        newSampleNames[index + i] = names[i]?.trim();
      setSampleNames(newSampleNames);
    }
    e.preventDefault();
    return false;
  };


  return (
    <Grid container spacing={2}>
      <form onSubmit={submitForm} style={{ width: "100%" }}>
        <Paper
          style={{
            margin: "70px auto",
            width: "90%",
            background: "#eff",
            marginTop: 20,
          }}
        >
          <h2
            style={{
              fontWeight: "bold",
              paddingTop: "20px",
              paddingBottom: "10px",
              textAlign: "center",
            }}
          >
            Sample Registrations
          </h2>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="flex-end"
            spacing={2}
            style={{ margin: "1rem auto" }}
          >
            <Grid item xs={12} sm={4} md={3}>
              <Autocomplete
                id="Project_id"
                onChange={(event, newValue) => {
                  setProject(newValue);
                }}
                defaultValue={projects?.projectId}
                options={projects?.results || []}
                inputValue={displayProject}
                blurOnSelect
                // disabled={subProject?.sampleRegistered!=""}
                getOptionLabel={(option: any) => {
                  return (
                    (option?.projectId) +
                    " " +
                    (option?.institute?.name || "") +
                    " " +
                    (option?.scientist?.name || "") +
                    "," +
                    (option?.dealer?.firmName || "")
                  );
                }}
                onInputChange={(event, newInputValue) => {
                  let data = newInputValue.split(" ");
                  clearTimeout(timer.current);
                  timer.current = setTimeout(() => {
                    if (data.length > 0) {
                      getProjects(`?projectId=${data[0]}`);
                    }
                  }, 1000);
                  setDisplayProject(newInputValue)
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="input"
                    label="Project Id"
                    placeholder="Search ID/Client/Dealer Name"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Autocomplete
                id="subProject_id"
                onChange={(event, newValue) => {
                  setSubProject(newValue);
                }}
                options={project?.subProjects || []}
                blurOnSelect
                getOptionLabel={(option: any) => option.title}
                inputValue={subproject}
                // disabled={subProject?.sampleRegistered!=""}
                onInputChange={(event, newInputValue) => {
                  setDisplaySubproject(newInputValue)
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="input"
                    label="SubProject Name"
                    placeholder="Select Subproject name"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <TextField
                fullWidth
                variant="outlined"
                label="Platforms"
                disabled
                className="input"
                value={subProject?.platform}
                style={{ width: "100%", height: "40px" }}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <TextField
                label="Application"
                variant="outlined"
                className="input"
                fullWidth
                disabled
                value={
                  applications[
                  subProject?.application?._id || subProject?.application
                  ]
                }
                style={{ width: "100%", height: "40px" }}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <TextField
                label="No Of Samples"
                variant="outlined"
                className="input"
                fullWidth
                disabled
                value={subProject?.sampleCount}
                style={{ width: "100%", height: "40px" }}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}></Grid>
            <Grid item xs={12} sm={4} md={3}></Grid>
          </Grid>

          <Grid
            container
            spacing={3}
            style={{ margin: "1rem auto", background: "#E0F2F1" }}
          >
            {sampleNames.map((value: string, index: number) => (
              <Grid item xs={12} sm={4} md={2}>
                <TextField
                  label="Sample Name"
                  variant="outlined"
                  className="input"
                  fullWidth
                  onPaste={(e) => handlePaste(index, e)}
                  value={value}
                  onChange={(e) => handleInputChange(index, e.target.value)}
                />
              </Grid>
            ))}
          </Grid>
          <Grid xs={12} style={{ textAlign: "center", padding: "20px" }}>
            <Button
              color="primary"
              variant="contained"
              type="submit"
              style={{ width: 300 }}
            >
              {subProject?.sampleRegistered ? "Update" : "Save"}
            </Button>
          </Grid>
        </Paper>
      </form>
    </Grid>
  );
};
const mapStateToProps = (state: any) => ({
  projects: state.GenomicsLabReducer.projects,
  projectFilterData: state.GenomicsLabReducer.projectFilterData,
  applications: state.GenomicsLabReducer.applications,
  projectSamplesdata: state.GenomicsLabReducer.projectSamplesdata,
});
export default connect(mapStateToProps, {
  getProjects,
  getProjectsFilter,
  createProjectSamples,
  updateSampleData,
  getApplications,
  getProjectSample,
})(Onboarding);
